import React, { useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import "./Login.css";
// import "react-toastify/dist/ReactToastify.css";
import signin from "../../Images/login-left.webp";
import { useMediaQuery, useTheme } from "@mui/material";

export default function AuthLeft() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <>

      <div className="login-left">
        {/* <Typography
                component="h1"
                variant="h5"
                className="login-left-title"
                sx={{ maxWidth: "400px", margin: "0 auto" }}
              >
                <span> Trade</span> on the go. Anywhere, Anytime.
              </Typography> */}
        {/* {lg && (
          <div className="auth-img">
            <img src={signin} alt="Ultrapro" className="login-left-img" />
          </div>
        )} */}
      </div>


    </>
  );
}
